import { render, staticRenderFns } from "./VisualizacionOyentesPopularidadArtistas.vue?vue&type=template&id=2684cf33&scoped=true&"
import script from "./VisualizacionOyentesPopularidadArtistas.vue?vue&type=script&lang=js&"
export * from "./VisualizacionOyentesPopularidadArtistas.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionOyentesPopularidadArtistas.vue?vue&type=style&index=0&id=2684cf33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684cf33",
  null
  
)

export default component.exports